export function compareVersions(a = '', b = '') {
    const left = String(a).split('.').map(v => Number(v) || 0);
    const right = String(b).split('.').map(v => Number(v) || 0);
    const length = Math.max(left.length, right.length);
    for (let i = 0; i < length; i += 1) {
        const diff = (left[i] || 0) - (right[i] || 0);
        if (diff !== 0) return diff;
    }
    return 0;
}
